var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterColorful = function SvgTwitterColorful(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0005 2.36084C6.6802 2.36084 2.36719 6.67651 2.36719 11.9998C2.36719 17.323 6.6802 21.6392 12.0005 21.6392C17.3209 21.6392 21.6341 17.3232 21.6341 11.9998C21.6341 6.67651 17.3209 2.36084 12.0005 2.36084ZM16.7031 9.60517C16.7031 9.60517 16.9321 10.741 16.1103 12.7363C15.2881 14.7317 13.2536 16.6192 10.4512 16.7945C7.64864 16.9697 6.13918 15.7293 6.13918 15.7293C8.2413 15.8912 9.17093 15.0283 9.66948 14.7452C7.71577 14.489 7.43277 13.0195 7.43277 13.0195C7.62133 13.1005 8.20066 13.0735 8.51065 12.9927C6.59758 12.5208 6.55711 10.593 6.55711 10.593C6.55711 10.593 7.27103 10.957 7.67529 10.8895C5.82919 9.48734 6.9074 7.65384 6.9074 7.65384C9.34617 10.3233 11.933 10.175 11.933 10.175L11.9447 10.1925C11.8977 10.0045 11.8724 9.80784 11.8724 9.60534C11.8724 8.27067 12.9538 7.18884 14.2877 7.18884C14.9922 7.18884 15.6264 7.49101 16.068 7.97267L16.0833 7.96401C16.9455 7.91001 17.5789 7.45167 17.5789 7.45167C17.3164 8.21901 16.7587 8.57651 16.5259 8.69684C16.5289 8.70401 16.5317 8.71117 16.5344 8.71817C16.8357 8.64517 17.644 8.44734 17.8621 8.38201C17.3902 9.24467 16.7031 9.60517 16.7031 9.60517Z",
    fill: "#2555EF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterColorful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TwitterColorful.65756695.svg";
export { ForwardRef as ReactComponent };